import type { ProfilePage, RosterRow } from "@amber/application/contracts";
import type { FirstPlan, PlanView } from "@amber/profiles/contracts";
import {
  EditIdentityPanel,
  LifecycleDialog,
  MergePanel,
  RefreshPanel,
  SplitPanel,
  type LifecycleKind,
} from "@amber/profiles/ui";
import { PersonPauseDialog, PlanEditor, ReviewSuggestions, StartTracking } from "@amber/collection/ui";
import type { SourceOption } from "@amber/collection/contracts";
import { useAppNavigate } from "@amber/ui";
import type { ProfilePanel } from "./pageState";

export function ProfilePanels({
  p,
  first,
  panel,
  lifecycle,
  rosterRow,
  roster,
  plan,
  options,
  onClosePanel,
  onCloseLifecycle,
}: {
  p: ProfilePage;
  first: FirstPlan | null;
  panel: ProfilePanel | null;
  lifecycle: LifecycleKind | null;
  rosterRow: RosterRow | undefined;
  roster: readonly RosterRow[];
  plan: PlanView | null;
  options: readonly SourceOption[] | undefined;
  onClosePanel: () => void;
  onCloseLifecycle: () => void;
}) {
  const navigate = useAppNavigate();
  return (
    <>
      {panel === "start" && first ? <StartTracking profile={p} plan={first} onClose={onClosePanel} /> : null}
      {panel === "review" && first ? <ReviewSuggestions profile={p} plan={first} onClose={onClosePanel} /> : null}
      {panel === "plan" && rosterRow && options ? (
        <PlanEditor
          key={String(plan?.latest.revision ?? 0)}
          person={rosterRow}
          personId={p.id}
          name={p.name}
          plan={plan}
          options={options}
          onClose={onClosePanel}
        />
      ) : null}
      {panel === "identity" ? <EditIdentityPanel key={p.revision} profile={p} onClose={onClosePanel} /> : null}
      {panel === "refresh" ? <RefreshPanel profile={p} onClose={onClosePanel} /> : null}
      {panel === "merge" ? <MergePanel profile={p} roster={roster} onClose={onClosePanel} /> : null}
      {panel === "split" ? <SplitPanel profile={p} onClose={onClosePanel} /> : null}
      {lifecycle ? <LifecycleDialog profile={p} kind={lifecycle} onClose={onCloseLifecycle} /> : null}
      {panel === "pause" && rosterRow ? (
        <PersonPauseDialog
          person={rosterRow}
          onClose={() => {
            onClosePanel();
            navigate(`/profiles/${p.id}`);
          }}
        />
      ) : null}
    </>
  );
}
